import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../helpers/SeoHelper";
import BrevetLevelAsContent from "../components/others/brevetScreen/BrevetLevelAsContent";
import BrevetScreenNavigationHeader from "../components/headers/brevetScreen/BrevetScreenNavigationHeader";
import SystemAppScreenHeader from "../components/headers/SystemAppScreenHeader";
import {kSystemIcons} from "../constants/icons";
import {useState} from "react";
import {kBrevetNavigation} from "../constants/navigation";
import BrevetScreenInfoDialog from "../components/dialogs/brevetScreen/BrevetScreenInfoDialog";
import BrevetExamsContent from "../components/others/brevetScreen/BrevetExamsContent";

export default function BrevetScreen() {
    // Used in index.js for the user to display brevet LevelAs

    // PROPERTIES
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
    const year = new Date().getFullYear();
    const [selectedBrevetScreen, setSelectedBrevetScreen] = useState(kBrevetNavigation[0].name);

    // BUILD
    return (
        <div className={"bg-backgroundLight3 w-full h-[100svh] flex flex-col justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle(`Ummia - Brevet ${year}`)}</title>
                <meta name="description"
                      content="Explications et exercices pour maitriser chaque savoir-faire fondamental du brevet." />
            </Helmet>
            {/** MODAL */}
            <BrevetScreenInfoDialog open={isInfoModalOpen}
                                    handleClose={processModalClosing} />
            {/** CONTENT */}
            <div className={"animate-appearSlow grow w-full flex flex-col justify-start items-center min-h-0"}>
                <div className={"w-full p-[16px]"}>
                    <SystemAppScreenHeader title={"Brevet 2026"}
                                           icon={kSystemIcons.school}
                                           onInfoClick={processModalOpening}
                                           isBrevetDisplay={true} />
                </div>
                <BrevetScreenNavigationHeader selectedBrevetScreen={selectedBrevetScreen}
                                              setSelectedBrevetScreen={setSelectedBrevetScreen} />
                {selectedBrevetScreen === kBrevetNavigation[0].name
                    ? <BrevetLevelAsContent />
                    : <BrevetExamsContent /> }
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isInfoModalOpen) {
            setIsInfoModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isInfoModalOpen) {
            setIsInfoModalOpen(false)
        }
    }
}